var V = Object.defineProperty, T = Object.defineProperties;
var j = Object.getOwnPropertyDescriptors;
var N = Object.getOwnPropertySymbols;
var K = Object.prototype.hasOwnProperty, E = Object.prototype.propertyIsEnumerable;
var C = (l, n, o) => n in l ? V(l, n, { enumerable: !0, configurable: !0, writable: !0, value: o }) : l[n] = o, D = (l, n) => {
  for (var o in n || (n = {}))
    K.call(n, o) && C(l, o, n[o]);
  if (N)
    for (var o of N(n))
      E.call(n, o) && C(l, o, n[o]);
  return l;
}, b = (l, n) => T(l, j(n));
var S = (l, n, o) => new Promise((g, f) => {
  var e = (r) => {
    try {
      m(o.next(r));
    } catch (u) {
      f(u);
    }
  }, y = (r) => {
    try {
      m(o.throw(r));
    } catch (u) {
      f(u);
    }
  }, m = (r) => r.done ? g(r.value) : Promise.resolve(r.value).then(e, y);
  m((o = o.apply(l, n)).next());
});
import "../../../node_modules/.pnpm/vue@3.5.18_typescript@5.2.2/node_modules/vue/dist/vue.runtime.esm-bundler.js";
import { getGetUserInfoPageListByCon as q } from "../../../request/ucenterapi/uc/internal/user/getUserInfoPageListByCon/get.js";
import P from "../../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/cloneDeep.js";
import { defineComponent as G, useTemplateRef as M, computed as R, openBlock as A, createElementBlock as H, createElementVNode as k, createVNode as c, withCtx as p, createTextVNode as x, Fragment as J } from "../../../node_modules/.pnpm/@vue_runtime-core@3.5.18/node_modules/@vue/runtime-core/dist/runtime-core.esm-bundler.js";
import { ref as U, reactive as O, unref as d } from "../../../node_modules/.pnpm/@vue_reactivity@3.5.18/node_modules/@vue/reactivity/dist/reactivity.esm-bundler.js";
import Q from "../../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/spin/src/Spin.js";
import W from "../../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/card/src/Card.js";
import F from "../../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/button/src/Button.js";
import X from "../../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/data-table/src/DataTable.js";
import Y from "../../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/pagination/src/Pagination.js";
import Z from "../../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/modal/src/Modal.js";
const $ = { class: "tw:flex tw:justify-end tw:pt-4" }, ee = { class: "tw:flex tw:justify-end tw:gap-2" }, ue = /* @__PURE__ */ G({
  name: "UserSelectedByCoditionDialog",
  __name: "userSelectedByCoditionDialog.ce",
  setup(l, { expose: n }) {
    const o = U(!1), g = M("conditionDialogContainer"), f = R(() => {
      const a = new Set(e.selectedUser.map((t) => t.userId));
      return e.tableData.filter((t) => a.has(t.id)).map((t) => t.id);
    }), e = O({
      tableData: [],
      selectedUser: [],
      pageForm: {
        currentPage: 1,
        pageSize: 10,
        total: 0
      },
      isLoading: !1,
      extendSearchParams: {}
    }), y = [
      { type: "selection" },
      { title: "姓名", key: "name", align: "center", ellipsis: { tooltip: !0 } },
      { title: "编码", key: "no", align: "center", ellipsis: { tooltip: !0 } },
      { title: "部门", key: "departmentName", align: "center", ellipsis: { tooltip: !0 } },
      { title: "岗位", key: "positionName", align: "center", ellipsis: { tooltip: !0 } }
    ], m = () => {
      e.selectedUser = [], e.extendSearchParams = {}, e.pageForm.currentPage = 1;
    }, r = U(null), u = (a) => S(this, null, function* () {
      return console.log("userSelectedByCoditionDialog params", a), o.value = !0, m(), e.selectedUser = P(a.selectedUser) || [], e.extendSearchParams = P(a.extendSearchParams) || {}, h(), new Promise((t) => {
        r.value = t;
      });
    }), w = () => {
      var a;
      o.value = !1, (a = r.value) == null || a.call(r, null), r.value = null;
    };
    n({ open: u, close: w });
    const v = () => {
      var t;
      o.value = !1;
      const a = {
        selectedUser: e.selectedUser
      };
      console.log("userSelectedByCoditionDialog confirm", a), (t = r.value) == null || t.call(r, a), r.value = null;
    }, h = () => S(this, null, function* () {
      try {
        e.isLoading = !0, e.tableData = [];
        const a = b(D({
          status: 1
        }, e.extendSearchParams), {
          pageSize: e.pageForm.pageSize,
          pageNum: e.pageForm.currentPage
        }), t = yield q(a);
        if (!t)
          return;
        e.tableData = t.records || [], e.pageForm.total = Number(t.total) || 0;
      } catch (a) {
        console.error(a);
      } finally {
        e.isLoading = !1;
      }
    }), z = (a) => {
      e.pageForm.pageSize = a, e.pageForm.currentPage = 1, h();
    }, _ = (a) => {
      e.pageForm.currentPage = a, h();
    }, B = (a) => {
      const t = new Set(e.tableData.map((s) => s.id)), i = e.selectedUser.filter((s) => !t.has(s.userId)), I = new Set(a.map((s) => String(s))), L = e.tableData.filter((s) => I.has(String(s.id))).map((s) => ({
        userId: s.id,
        userName: s.name,
        departmentId: s.departmentId,
        departmentName: s.departmentName,
        account: s.account,
        orgNo: s.orgNo
      }));
      e.selectedUser = i.concat(L);
    };
    return (a, t) => (A(), H(J, null, [
      k("div", {
        ref_key: "conditionDialogContainer",
        ref: g
      }, null, 512),
      c(d(Z), {
        bordered: "",
        show: o.value,
        "onUpdate:show": t[2] || (t[2] = (i) => o.value = i),
        "mask-closable": !1,
        "z-index": 1e4,
        to: g.value || "body"
      }, {
        default: p(() => [
          c(d(Q), {
            show: e.isLoading
          }, {
            default: p(() => [
              c(d(W), {
                style: { width: "1000px" },
                title: "选择人员",
                bordered: !1,
                role: "dialog",
                closable: "",
                onClose: w
              }, {
                footer: p(() => [
                  k("div", ee, [
                    c(d(F), { onClick: w }, {
                      default: p(() => t[3] || (t[3] = [
                        x("取消", -1)
                      ])),
                      _: 1,
                      __: [3]
                    }),
                    c(d(F), {
                      type: "primary",
                      onClick: v
                    }, {
                      default: p(() => t[4] || (t[4] = [
                        x("添加", -1)
                      ])),
                      _: 1,
                      __: [4]
                    })
                  ])
                ]),
                default: p(() => [
                  c(d(X), {
                    columns: y,
                    data: e.tableData,
                    bordered: !0,
                    "max-height": 440,
                    "min-height": 440,
                    "row-key": (i) => i.id,
                    "checked-row-keys": f.value,
                    "onUpdate:checkedRowKeys": B
                  }, null, 8, ["data", "row-key", "checked-row-keys"]),
                  k("div", $, [
                    c(d(Y), {
                      page: e.pageForm.currentPage,
                      "onUpdate:page": [
                        t[0] || (t[0] = (i) => e.pageForm.currentPage = i),
                        _
                      ],
                      "page-size": e.pageForm.pageSize,
                      "onUpdate:pageSize": [
                        t[1] || (t[1] = (i) => e.pageForm.pageSize = i),
                        z
                      ],
                      "item-count": e.pageForm.total,
                      "page-sizes": [10, 20, 30, 50],
                      "show-size-picker": "",
                      "show-quick-jumper": ""
                    }, null, 8, ["page", "page-size", "item-count"])
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["show"])
        ]),
        _: 1
      }, 8, ["show", "to"])
    ], 64));
  }
});
export {
  ue as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/components/userSelectedDialog/components/userSelectedByCoditionDialog.ce.vue.js
// module id = 1292
// module chunks = 41